// @ts-check
import { gql } from '@apollo/client';
import React from 'react';
import { PagesProvider } from '../../../pdf-design-system/Base/PageLayout/Page';
import { ThemeProvider } from '../../../pdf-design-system/useTheme';
import UserLocaleProvider from '../../../Providers/UserLocaleProvider';
import messages from '../locale/messages';
import VieVinumExhibitorIndex from './VieVinumExhibitorIndex';
import VieVinumIntro from './VieVinumIntro';
import VieVinumRooms from './VieVinumRooms';
import theme from './vievinumTheme';

/**
 *
 * @param {{
 * data: import('./@types/VieVinumCatalog').VieVinumCatalogFragment;
 * locale: import('@bottlebooks/graphql-server/src').ContentLocale
 * bleed?: number;
 * }} props
 * @returns
 */
export default function VieVinumCatalog({ data, locale, bleed = 3, ...rest }) {
  return (
    <PagesProvider>
      <ThemeProvider theme={theme}>
        <UserLocaleProvider locale={locale} messages={messages}>
          <VieVinumIntro bleed={bleed} {...rest} />
          <VieVinumRooms data={data} bleed={bleed} {...rest} />
          <VieVinumExhibitorIndex data={data} bleed={bleed} {...rest} />
        </UserLocaleProvider>
      </ThemeProvider>
    </PagesProvider>
  );
}

const parse = gql;
VieVinumCatalog.fragment = parse/* GraphQL */ `
  fragment VieVinumCatalog on CatalogConfiguration {
    catalogConfigurationId
    ...VieVinumRooms
    ...VieVinumExhibitorIndex
  }
  # There is no fragment in the intro - its content read from the static rooms helper file.
  # $ {VieVinumIntro.fragment}
  ${VieVinumRooms.fragment}
  ${VieVinumExhibitorIndex.fragment}
`;
